var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.71967 0.21967C1.01256 -0.0732233 1.48744 -0.0732233 1.78033 0.21967L5.75 4.18934L9.71967 0.21967C10.0126 -0.0732233 10.4874 -0.0732233 10.7803 0.21967C11.0732 0.512563 11.0732 0.987437 10.7803 1.28033L6.81066 5.25L10.7803 9.21967C11.0732 9.51256 11.0732 9.98744 10.7803 10.2803C10.4874 10.5732 10.0126 10.5732 9.71967 10.2803L5.75 6.31066L1.78033 10.2803C1.48744 10.5732 1.01256 10.5732 0.71967 10.2803C0.426777 9.98744 0.426777 9.51256 0.71967 9.21967L4.68934 5.25L0.71967 1.28033C0.426777 0.987437 0.426777 0.512563 0.71967 0.21967Z",
    fill: "#C15000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.4ecc6dad4f4ee6a77d1ab20afd693412.svg";
export { ForwardRef as ReactComponent };